import { MEMORY_UNIT_SUFFIXES } from '@cast/constants';

export enum CpuType {
  ON_DEMAND = 'onDemand',
  FALLBACK = 'fallback',
  SPOT = 'spot',
  NORMALIZED = 'normalized',
}

export enum ComputeResourceType {
  CPU = 'cpu',
  MEMORY = 'memory',
}

export type ComputeResourceTypeValue = `${ComputeResourceType}`;

export enum ComputeResourceTypeExtended {
  CPU = 'cpu',
  MEMORY = 'memory',
  GPU = 'gpu',
  TPU = 'tpu',
}

export type MemoryUnits = (typeof MEMORY_UNIT_SUFFIXES)[number];

export type ResourceMetric<UNIT extends string = string> = {
  amount: number;
  unit: UNIT;
};

export type Memory = ResourceMetric<MemoryUnits>;
